import { useSelector } from 'react-redux'

import { selectPreapprovalAmountPercentage } from '@store/rootResource'

const usePreapprovalAmountPercentage = (): number => useSelector(selectPreapprovalAmountPercentage)

export { usePreapprovalAmountPercentage }
